<div class="close closeModal" *ngIf="ventanaOrigenValue() != 'login'">
  <a (click)="close()" title="{{ 'CERRAR' | translate }}"
    ><span class="cross"></span
    ><span class="sr-only">{{ 'CERRAR' | translate }}</span></a
  >
</div>
<div id="tabDesglosar">
  <fieldset class="encuadrar">
    <div class="tituloInt tituloPago">{{ obtenerTitulo() | translate }}</div>
    <div class="tituloInt tituloPago">
      {{ 'DESGLOSE_DEL_CAMBIO' | translate }}
    </div>
    <div class="desgloseWrap">
      <div class="entradas" [formGroup]="billetesMonedasForm" *ngIf="loaded">
        <div
          class="Rtable-cell desglose-cell"
          (click)="selectMoneda($event, moneda, i)"
          [ngClass]="{
            active: !isMonedaseleccionada(moneda),
            select: isMonedaseleccionada(moneda)
          }"
          *ngFor="let moneda of controlDataMap | keyvalue:null; let i = index"
        >
          <div class="Rtable-cell--content row">
            <img
              style="margin-top: 10px"
              src="assets/img/monedas/{{ moneda.value['Imagen'] }}"
              alt="{{ moneda.value['Nombre'] }}"
            />
          </div>
          <div class="Rtable-cell--content row">
            {{ moneda.value['Nombre'] }}
          </div>
          <div class="Rtable-cell--content row">
            {{ 'JUSTIFICANTE_UNIDADES' | translate }}:
          </div>
          <input
            id="{{ moneda.value['pkid'] }}"
            type="text"
            class="qty-desglose text"
            name="quantity"
            category="DESGLOSE"
            [formControlName]="moneda.value['Valor']"
            [autofocus]="actualFocus == i"
            (focus)="focusValueMonedas($event, moneda, i)"
            (input)="actualizarMoneda($event, moneda, i)"
            autocomplete="nope"
            title="quantity"
            size="4"
          />
        </div>
      </div>
      <div class="gestionInputWrap" [formGroup]="desgloseForm">
        <div
          class="form-group readonly"
          *ngIf="tienePermiso('TurnoArqueoCiego')"
        >
          <div class="tit-form-group">
            <label for="ventasEfectivoInput">{{
              'TOTAL_DESGLOSE' | translate
            }}</label>
          </div>
          <input
            type="text"
            class="form-control"
            formControlName="ventasEfectivo"
            id="ventasEfectivoInput"
            value="{{
              obtenerCambio() || 0
                | myCurrency
                  : divisaSimboloDecimal
                  : divisaDecimales
                  : divisaPosicion
                  : divisaSimbolo
                  : divisaSimboloDerecha
                  : divisaSimboloDerecha
                  : divisaSimbSeparacionMiles
            }}"
            readonly
          />
        </div>
        <div
          *ngIf="ventanaOrigenValue() != 'login'"
          class="form-group readonly"
        >
          <div class="tit-form-group">
            <label for="cierreEfectivo">{{
              'CAMBIO_EXISTENTE' | translate
            }}</label>
          </div>
          <input
            type="text"
            #cambioEfectivo
            category="DIVISA"
            formControlName="cambioExistente"
            #efectivo
            class="form-control"
            id="arqueoEfectivo"
            [placeholder]="placeholderValue"
            (focus)="focusValue($event)"
            value="{{
              cambio.ventasEfectivo
                | myCurrency
                  : divisaSimboloDecimal
                  : divisaDecimales
                  : divisaPosicion
                  : divisaSimbolo
                  : divisaSimboloDerecha
                  : divisaSimboloDerecha
                  : divisaSimbSeparacionMiles
            }}"
            readonly
          />
        </div>
        <div
          *ngIf="ventanaOrigenValue() != 'login'"
          class="form-group readonly"
        >
          <div class="tit-form-group">
            <label for="diferenciaInput">{{ 'DIFERENCIA' | translate }}</label>
          </div>
          <input
            type="text"
            class="form-control"
            id="diferenciaInput"
            formControlName="diferencia"
            value="{{
              diferencia
                | myCurrency
                  : divisaSimboloDecimal
                  : divisaDecimales
                  : divisaPosicion
                  : divisaSimbolo
                  : divisaSimboloDerecha
                  : divisaSimboloDerecha
                  : divisaSimbSeparacionMiles
            }}"
            readonly
          />
        </div>
        <div
          *ngIf="debeMostrarBolsaCambio()"
          class="form-group bolsaCambio"
        >
          <div class="tit-form-group">
            <label for="bolsaDeCambio">{{ 'BOLSA_DE_CAMBIO' | translate }}<span class="bolsa-cambio-asterisco" *ngIf="bolsaCambioEsObligatoria()"> *</span></label>
          </div>
          <input
            type="text"
            #cambioBolsa
            formControlName="bolsaCambio"
            category="BOLSACAMBIO"
            class="form-control"
            [ngClass]="{ 'active-form': isSelected(cambioBolsa), 'bolsa-cambio-invalida': bolsaCambioObligatoriaInvalida() }"
            id="bolsaDeCambio"
            (focus)="focusValue($event)"
          />
        </div>
        <div class="form-group textarea">
          <div class="tit-form-group">
            <label for="comentarios">{{ 'COMENTARIOS' | translate }}</label>
          </div>
          <textarea
            formControlName="comentario"
            #comentario
            (focus)="focusValue($event)"
            category="TEXTAREA"
            class="form-control"
            rows="2"
            cols="40"
            id="comentarios"
            [ngClass]="{ 'active-form': isSelected(comentario) }"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="btn-continuar-wrap">
      <a
        class="SiguienteButton ArqueoParcial"
        [ngClass]="{ disabled: !puedeConfirmar() }"
        title="ARQUEO PARCIAL"
        (click)="GuardarDesglose()"
        >{{ 'CONFIRMAR' | translate }}</a
      >
    </div>
  </fieldset>
  <div class="keyboardWrap">
    <ticketing-keyboard></ticketing-keyboard>
    <ticketing-numpad></ticketing-numpad>
  </div>
</div>
